export const isRugProduct = (attributeSetId?: number | null) =>
  attributeSetId && attributeSetId === 115
